import {addCompletedQuest, incrementOnlineGamesPlayed, updatePlayerRewards} from "../../redux/actions";

/**
 * Что применить к локальному профилю по итогам матча — из СВОЕЙ строки
 * расширенных результатов (см. finalizeGame на сервере).
 *
 * Вынесено из обработчика сообщений лобби отдельной функцией, потому что
 * правило «что именно гасить» тут не самоочевидное и один раз уже было
 * ошибочным: задания помечались выполненными по типу награды, из-за чего
 * после первого рейтингового матча локально гасло задание обычного сетевого,
 * а задания на лиги не гасли вовсе — они закрываются без наградной модалки,
 * и до перезагрузки страницы «Задания» показывала их невыполненными.
 * Теперь список закрытых заданий приходит с сервера полем completedQuestIds.
 *
 * Сюда же — счетчики сыгранных сетевых матчей: строка результатов приходит
 * только по сети (finalizeGame), то есть ровно за сетевой матч, который сервер
 * уже засчитал в onlineGamesPlayed (и в rankedGamesPlayed, если матч
 * рейтинговый — isRanked берется из состояния партии)
 *
 * @param {Object} ownResult - строка результатов своего игрока
 * @param {Object} [options]
 * @param {boolean} [options.isRanked=false] - матч был рейтинговым
 * @returns {Array<Object>} экшены к диспатчу по порядку
 */
export const getOwnMatchResultProfileActions = (ownResult, {isRanked = false} = {}) => {
  if (!ownResult) {
    return [];
  }

  const hasNewChests = (ownResult.chests || []).length > 0;
  const hasNewSkins = (ownResult.skins || []).length > 0;

  return [
    updatePlayerRewards(
      ownResult.numens,
      ownResult.rating,
      (hasNewChests || hasNewSkins) || undefined,
      undefined,
      Boolean(ownResult.isDoubleReward),
    ),
    ...(ownResult.completedQuestIds || []).map((questId) => addCompletedQuest(questId)),
    incrementOnlineGamesPlayed({isRanked}),
  ];
};
